import { getConfig } from './config';

export function isTemplate() {
  return getConfig().sectionUrl.indexOf('//www.wix.com/') > -1;
}
